module.exports = __webpack_public_path__ + "static/011.thumb-d5acf1a439eb00deb5eb77620f776e74.jpg";